interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "BOB";
};

const BOB: Currency = Object.freeze({
  "displayName": "Bolivian Boliviano",
  "numericCode": 68,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "BOB",
  "symbol": "Bs."
});

export { BOB };
